"use strict";

$.extend(Fotobook, {
    mouse: {
        "clientX" : 0,
        "clientY" : 0,
        "pageX"   : 0,
        "pageY"   : 0,
        "screenX" : 0,
        "screenY" : 0,
    },
});

$(document)
.on("mousemove", function(e){
    for (var i in Fotobook.mouse){
        if (Fotobook.mouse.hasOwnProperty(i)) {
            Fotobook.mouse[i] = e[i];
        }
    }
});